module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/candle@3x_634884.png";